import Icons from "../../../../../shared/constants/icon.constant";
import ComingSoon from "../../../../../shared/components/ComingSoon";

const investmentsRoutes = {
  path: "investment",
  label: "Investment",
  icon: Icons.Investment({ width: 16, height: 16 }),
  children: [
    {
      path: "overview",
      label: "Overview",
      icon: Icons.Overview({ width: 16, height: 16 }),
      element: <ComingSoon />,
      comingSoon: true,
    },
    {
      path: "crypto",
      label: "Crypto",
      icon: Icons.Crypto({ width: 16, height: 16 }),
      element: <ComingSoon />,
      comingSoon: true,
    },
    {
      path: "staking",
      label: "Staking",
      icon: Icons.Staking({ width: 16, height: 16 }),
      element: <ComingSoon />,
      comingSoon: true,
    },
    {
      path: "stocks",
      label: "Stocks",
      icon: Icons.Stocks({ width: 16, height: 16 }),
      element: <ComingSoon />,
      comingSoon: true,
    },
    {
      path: "advice",
      label: "Advice",
      icon: Icons.Advice({ width: 16, height: 16 }),
      element: <ComingSoon />,
      comingSoon: true,
    },
  ],
};
export default investmentsRoutes;
